import { render, staticRenderFns } from "./confirmData.vue?vue&type=template&id=1f1047da&scoped=true&"
import script from "./confirmData.vue?vue&type=script&lang=js&"
export * from "./confirmData.vue?vue&type=script&lang=js&"
import style0 from "./confirmData.vue?vue&type=style&index=0&id=1f1047da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1047da",
  null
  
)

export default component.exports